const noSpacingVariants = {
	HERO: 'heroBlock',
	CAMPAIGN_HERO: 'campaignHeroBlock',
	CAMPAIGN_CONTENT: 'campaignContentBlock',
	BANNER: 'bannerBlock',
	CAMPAIGN_VIDEO: 'campaignVideoBlock',
};

export default noSpacingVariants;
